import { render, staticRenderFns } from "./IconThreads.vue?vue&type=template&id=b64fdfba&scoped=true&"
import script from "./IconThreads.vue?vue&type=script&lang=js&"
export * from "./IconThreads.vue?vue&type=script&lang=js&"
import style0 from "./IconThreads.vue?vue&type=style&index=0&id=b64fdfba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64fdfba",
  null
  
)

export default component.exports